module.exports = __webpack_public_path__ + "assets/mail-red_icon.17701d81.svg";